import { Sheet, SheetContent } from '@/components/ui/sheet';
import { useCreateTerminKalenderForm } from '@/domain/termine/features/CreateTerminKalender/shared/hooks/useCreateTerminKalenderForm';
import { CreateTerminKalenderSheetHeader } from '@/domain/termine/features/CreateTerminKalender/Sheet/CreateTerminKalenderSheetHeader';
import { CreateTerminKalenderSheetForm } from '@/domain/termine/features/CreateTerminKalender/Sheet/CreateTerminKalenderSheetForm';

type CreateTerminKalenderSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CreateTerminKalenderSheet({
  open,
  onOpenChange,
}: CreateTerminKalenderSheetProps) {
  const form = useCreateTerminKalenderForm();

  const handleSubmitSuccess = () => {
    form.reset();
    onOpenChange(false);
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) form.reset();
    onOpenChange(isOpen);
  };

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent
        className="flex flex-col h-full p-0 w-full sm:max-w-md"
        removeCloseIcon>
        <CreateTerminKalenderSheetHeader />
        <CreateTerminKalenderSheetForm
          form={form}
          onSubmitSuccess={handleSubmitSuccess}
        />
      </SheetContent>
    </Sheet>
  );
}
